var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgramaSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.834,
    y: 11.3242,
    width: 45.2971,
    height: 45.2971,
    rx: 12.0792,
    fill: "#1C5029"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_407_15315)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.1582,
    y: 23.4036,
    width: 60.3962,
    height: 60.3962,
    rx: 12.0792,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7807,
    y: 23.0261,
    width: 61.1511,
    height: 61.1511,
    rx: 12.4567,
    stroke: "url(#paint0_linear_407_15315)",
    strokeOpacity: 0.5,
    strokeWidth: 0.754952
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6449 63.5598L54.0243 64.3621L53.6449 63.5598L46.0261 67.1634L47.099 58.8039C47.1752 58.2099 46.9813 57.613 46.5705 57.1773L40.7889 51.045L49.0708 49.4822C49.6592 49.3711 50.167 49.0022 50.4544 48.4769L54.5 41.0833L58.5456 48.4769C58.833 49.0022 59.3408 49.3711 59.9292 49.4822L68.2111 51.045L62.4295 57.1773C62.0187 57.613 61.8248 58.2099 61.901 58.8039L62.9739 67.1634L55.3551 63.5598L54.9276 64.4637L55.3551 63.5598C54.8138 63.3037 54.1862 63.3037 53.6449 63.5598Z",
    stroke: "#1C5029",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_407_15315",
    x: 8.30427,
    y: 7.54963,
    width: 92.1043,
    height: 92.1041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.54952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_407_15315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_407_15315",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_15315",
    x1: 24.1582,
    y1: 23.4036,
    x2: 104.938,
    y2: 117.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgramaSecondary);
export default __webpack_public_path__ + "static/media/iconProgramaSecondary.238c828a5d9ec3b56875ca62ed3441de.svg";
export { ForwardRef as ReactComponent };